const getPrescriberPhone2 = ({ patient, prescriber, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (prescriber && prescriber.Phone) {
    return prescriber.Phone.replace('+1 ', '').replace(/[\s()-]/g, '').slice(3, 6);
  }
  if (patient.Prescriber[0] && patient.Prescriber[0].Phone) {
    return patient.Prescriber[0].Phone.replace('+1 ', '').replace(/[\s()-]/g, '').slice(3, 6);
  }
  return null;
};

export default getPrescriberPhone2;



// WEBPACK FOOTER //
// ./src/utils/print/getPrescriberPhone2.js